import React, { useRef } from 'react';
import './App.scss';
import Header from './Components/common-header/Header';
import Hero from './Components/sections/Hero';
import Sections from './Components/sections/Sections';
import Footer from './Components/common-footer/Footer';
import RelatedContents from './Components/relatedContents/RelatedContents';

function App() {
  const heroRef = useRef();
  return (
    <main className="App" id="top">
      <Header clientName="Intel Corporation" />
      <Hero heroRef={heroRef} />
      <Sections heroRef={heroRef} />
      <RelatedContents />
      <Footer />
    </main>
  );
}

export default App;
